module.exports = "/* Border for table cells */\r\ntable td, table th {\r\n  border: 1px solid #ddd;\r\n}\r\n/* Scroll container for the table */\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/status/statusview/statusview.component.css
// module id = ./src/app/applicant/status/statusview/statusview.component.css
// module chunks = main